/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('select[name="locale_code"], select[name="country_code"]');
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.inputs.forEach(item => item.addEventListener('change', this.debouncedOnSubmit.bind(this)));

      this.flagOptions = this.querySelectorAll('.thb-flag-dropdown__option');
      this.flagOptions.forEach(btn => btn.addEventListener('click', this.onFlagSelect.bind(this)));

      this.flagDropdown = this.querySelector('.thb-flag-dropdown');
      if (this.flagDropdown) {
        document.addEventListener('click', this.onDocumentClick.bind(this));
      }
    }
    onFlagSelect(event) {
      const btn = event.currentTarget;
      const localeCode = btn.dataset.localeCode;
      const countryCode = btn.dataset.countryCode;
      let select;
      let value;
      if (localeCode) {
        select = this.form.querySelector('select[name="locale_code"]');
        value = localeCode;
      } else if (countryCode) {
        select = this.form.querySelector('select[name="country_code"]');
        value = countryCode;
      }
      if (!select || !value) return;
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    onDocumentClick(event) {
      if (!this.flagDropdown.open) return;
      if (!this.flagDropdown.contains(event.target)) {
        this.flagDropdown.open = false;
      }
    }
    onSubmitHandler(event) {
      if (this.form) this.form.submit();
    }
  }
  customElements.define('localization-form', LocalizationForm);
}